gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".fade-in-up").forEach((element) => {
    gsap.from(element, {
        scrollTrigger: {
            trigger: element,
            start: "top 85%", // Start the animation when the top of the element is 80% from the top of the viewport
            toggleActions: "play none none none" // Play the animation once when the element comes into view
        },
        opacity: 0,
        y: 30, // Adjust the starting position
        duration: 1,
        ease: "power2.out",
    });
});
